class ProductDetails extends HTMLElement {
  constructor() {
    super();
    this.buttons = null;
    this.contents = null;
  }

  connectedCallback() {
    this.initializeTabs();
  }

  initializeTabs() {
    this.buttons = this.querySelectorAll('.js-detail-tab-button');
    this.contents = this.querySelectorAll('.js-detail-tab-content');

    if (!this.buttons.length || !this.contents.length) {
      return;
    }

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.handleTabClick(button);
      });
    });
  }

  handleTabClick(clickedButton) {
    const targetTab = clickedButton.dataset.tab;

    // Update buttons
    this.buttons.forEach((btn) => {
      btn.setAttribute('aria-selected', 'false');
    });
    clickedButton.setAttribute('aria-selected', 'true');

    // Update contents
    this.contents.forEach((content) => {
      content.classList.add('jc-hidden');
      content.setAttribute('aria-hidden', 'true');
    });

    const targetContent = this.querySelector(`[data-tab-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.remove('jc-hidden');
      targetContent.setAttribute('aria-hidden', 'false');
    }
  }
}

customElements.define("product-details", ProductDetails);
